import VueRouter from "vue-router";

const EXPECTED_FAILURE_NAMES = {
  NavigationDuplicated: true,
  NavigationCancelled: true,
  NavigationAborted: true,
  NavigationRedirected: true,
};

const EXPECTED_FAILURE_MESSAGES = [
  /^Navigation cancelled/,
  /^Navigation aborted/,
  /^Redirected when going from/,
  /Avoided redundant navigation/,
];

function isTypeError(err) {
  return err instanceof TypeError || err.name === "TypeError";
}

function isDocumentedNavigationFailureType(type) {
  const types = VueRouter.NavigationFailureType;
  if (types == null || type == null) return false;
  return (
    type === types.redirected
    || type === types.aborted
    || type === types.cancelled
    || type === types.duplicated
  );
}

export function isExpectedNavigationFailure(err) {
  if (err == null || typeof err !== "object") return false;
  if (isTypeError(err)) return false;

  if (
    typeof VueRouter.isNavigationFailure === "function"
    && VueRouter.isNavigationFailure(err)
  ) {
    return true;
  }

  if (err._isRouter === true && isDocumentedNavigationFailureType(err.type)) {
    return true;
  }

  if (err.name && EXPECTED_FAILURE_NAMES[err.name]) return true;

  const message = typeof err.message === "string" ? err.message : "";
  return EXPECTED_FAILURE_MESSAGES.some((pattern) => pattern.test(message));
}

export function wrapRouterMethod(originalFn, methodName = "push") {
  return function safeNavigate(location, onComplete, onAbort) {
    if (location == null) {
      console.warn(`[router] ${methodName} ignorado: destino é null/undefined`);
      if (typeof onComplete === "function") onComplete();
      return Promise.resolve();
    }

    return Promise.resolve()
      .then(() => originalFn(location))
      .then((route) => {
        if (typeof onComplete === "function") onComplete(route);
        return route;
      })
      .catch((err) => {
        // Falha esperada (cancelled/duplicated/aborted/redirected) é silenciosa,
        // como no modo callback nativo do vue-router: não aciona onAbort.
        if (isExpectedNavigationFailure(err)) return undefined;
        if (typeof onAbort === "function") onAbort(err);
        throw err;
      });
  };
}
